<template>
  <div>
    <div class="columns is-centered">
      <div class="column is-narrow">
        <table class="table">
          <tbody>
            <tr>
              <th>Order Date</th>
              <td>{{orderDateFormatted}}</td>
            </tr>
            <tr v-if="order.order_id !== 'Review'">
              <th>Order Number</th>
              <td>{{order.order_id}}</td>
            </tr>
            <tr>
              <th>PO/SM</th>
              <td>{{order.po_sm}}</td>
            </tr>
            <tr>
              <th>Product</th>
              <td>{{productFormatted}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="column is-narrow">
        <table class="table">
          <tbody>
            <tr v-if="hasQuotedAmount" :class="hasRelatedOrders? 'grouped-cells qa-grouped-cells' : ''">
              <th>Quoted Amount</th>
              <td>{{order.quoted_amount}}</td>
            </tr>
            <tr v-if="hasRelatedOrders" :class="hasQuotedAmount? 'grouped-cells ro-grouped-cells' : ''">
              <th>Linked Orders</th>
              <td>
                <span v-for="(id, idx) in order.related_orders" :key="idx">
                  <router-link
                    :to="{ name: 'order', params: { customerId: order.customer_id, orderId: `${id}` }}"
                  >
                    {{id}}
                  </router-link>
                  <span v-if="idx !== order.related_orders.length -1">,</span>
                </span>
              </td>
            </tr>
            <tr v-if="order.order_id !== 'Review'">
              <th>Customer Service Rep:</th>
              <td>
                 <a :href="`mailto:${order.rep_email}?subject=Inquiry re: Order ID ${order.order_id}, PO ${order.po_sm}`">
                  {{repFormated}}
                </a>
              </td>
            </tr>
            <tr v-if="order.order_id !== 'Review'">
              <th>Status:</th>
              <td>{{status}} <a v-if="order.box_report" :href="`https://api.elitedecorinc.com/api/v1/orders/${order.order_id}/files?type=BoxReport&format=pdf&authToken=${authToken}`">Box Report</a></td>
            </tr>
            <tr v-if="status === 'Delivered/Picked Up'">
              <th>{{status}}</th>
              <td>{{deliveryDate}} <a v-if="order.signed_packing_slip" :href="`https://api.elitedecorinc.com/api/v1/orders/${order.order_id}/files?type=Signed&format=pdf&authToken=${authToken}`">Proof of Delivery</a></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    order: Object,
  },
  computed: {
    authToken() {
      return encodeURIComponent(localStorage.getItem('ed-authToken'));
    },
    hasQuotedAmount() {
      return this.order.quoted_amount && this.order.quoted_amount !== '$0.00';
    },
    product() {
      return this.order.category;
    },
    deliveredADayAgoOrMore() {
      return moment.duration(moment().diff(moment(this.order.delivered_on))).asDays() > 1;
    },
    status() {
      console.log(this.order);
      if (this.order.delivered_on && this.deliveredADayAgoOrMore) {
        return 'Delivered/Picked Up';
      }
      if (this.order.delivered_on) {
        return 'Delivery/Pick Up Scheduled';
      }
      if (this.order.completed) {
        return 'Completed';
      }
      if (this.order.status || this.order.status === '') {
        return 'On Hold';
      }
      if (this.order.ready_to_print) {
        if (!this.order.wip && ['drapes', 'fab shades'].includes(this.order.category)) {
          return 'Waiting for fabric';
        }
        return 'In Production';
      }
      return 'Processing';
    },
    deliveryDate() {
      if (this.order.delivered_on) {
        console.log(this.order.delivered_on);
        return moment.utc(this.order.delivered_on).startOf('day').format('MM/DD/YY');
      }
      return '';
    },
    productFormatted() {
      if (this.product) {
        if (this.product === 'fab shades') return 'Roman Shades';
        return this.product.replace(/^\w/, c => c.toUpperCase());
      }
      return '';
    },
    repFormated() {
      return (this.order.rep_name && this.order.rep_name.replace(/^\w/, c => c.toUpperCase())) || '';
    },
    orderDateFormatted() {
      console.log(this.order.order_date);
      return moment.utc(this.order.order_date).startOf('day').format('MM/DD/YY');
    },
    hasRelatedOrders() {
      return this.order.related_orders && this.order.related_orders.length > 0;
    },
  },
};
</script>

<style scoped>
.table td, .table th {
  border: none;
  padding: 0.1em;
}

.grouped-cells {
  border-color: #f00;
  border-right: 1px solid #ccc;
  border-left: 1px solid #ccc;
}

.qa-grouped-cells {
  border-top: 1px solid #ccc;

}
.ro-grouped-cells {
  border-bottom: 1px solid #ccc;

}
</style>
